<template>
    <div class="popup visible" id="edit-profile-popup" @click.stop="">
        <div class="max-w-content">
            <p class="box-title center">Редактирование сотрудника</p>
            <div class="profile-photo" @click="handleImageClick">
                <img :src="temp.image" alt="">
                <input id="file-id" type="file" ref="file" name="attachment" class="file-input-field">
                <span class="edit-icon">
                    <icon-base width="18" height="18" viewBox="0 0 17 17"><icon-pencil fill="#fff"/></icon-base>
                </span>
            </div>
            <p class="in-agency-from">В агенстве с 28.06.2018</p>
            <form class="form edit-profile-form" ref="form">
                <field-group-wrapper>
                    <field-wrapper type="text" v-model="temp.name" label="Имя" :options="{required: true}"></field-wrapper>
                    <field-wrapper v-model="temp.sername" label="Фамилия" :options="{required: true}"></field-wrapper>
                    <field-wrapper v-model="temp.patronymic" label="Отчество" :options="{required: true}"></field-wrapper>
                </field-group-wrapper>
                <field-group-wrapper class="small-size">
                    <field-wrapper  v-model="temp.dateOfEmployment" type="date" :label="temp.groupId === 2 ? 'В агенстве с' : 'Стажируется с'"></field-wrapper>
                </field-group-wrapper>
                <field-group-wrapper>
                    <field-wrapper v-model="temp.mails" type="email" label="Email" :options="{required: true}" clone></field-wrapper>
                    <field-wrapper  v-model="values" type="group" label="Телефоны" :options="groupFieldsOptions" clone></field-wrapper>
                </field-group-wrapper>
                <field-group-wrapper>
                    <field-wrapper v-model="temp.position" label="Должность" :options="{required: true}"></field-wrapper>
                    <field-wrapper v-model="temp.subPositions" label="Статус" type="select" :options="{ values: ['Директор','Менеджер','Маркетолог','Дизайнер']}" clone></field-wrapper>
                </field-group-wrapper>
                <p v-show="!loading">{{formMessage}}</p>
                <button v-show="!loading" type="button" class="btn" @click="sendData">Сохранить</button>
                <pre-loader-component :small="true" :visible="loading"></pre-loader-component>
            </form>
        </div>
        <span class="js-close-popup" title="Закрыть" @click="$emit('close')">
            <icon-base width="14" height="14" viewBox="0 0 14 14"><icon-close/></icon-base>
        </span>
    </div>
</template>

<script>

    import {mapActions, mapState} from 'vuex'
    import PreLoaderComponent from "../common/PreLoader";
    import IconBase from "../common/IconBase";
    import IconClose from "../common/icons/IconClose";
    import IconPencil from "../common/icons/IconPencil";
    import FieldGroupWrapper from "../common/fields/FieldsGroupWrapper";
    import FieldWrapper from "../common/fields/FieldWrapper";

    export default {
        name: 'edit-profile-form',
        components: {
            FieldWrapper,
            FieldGroupWrapper,
            IconPencil,
            IconClose,
            IconBase,
            PreLoaderComponent,
        },
        computed: {
            ...mapState({
                employee: state => state.people.currentEmployee
            })
        },
        data() {
            return {
                loading: false,
                formMessage: '',
                groupFieldsOptions: {
                    required: true,
                    fields: [
                        {
                            id: 6341246,
                            type: 'select',
                            options: {
                                values: ['рабочий', 'личный']
                            },
                        },
                        {
                            id: 43335,
                            type: 'tel',
                            options: {
                                required: true
                            },
                        },
                    ]
                },
                values: [

                ],
                temp: {}
            }
        },
        methods: {
            ...mapActions('people', [
                'saveProfile'
            ]),
            ...mapActions([
                'switchPopup'
            ]),
            sendData() {
                if (!this.$refs.form.checkValidity()) {
                    this.$refs.form.reportValidity();
                    this.formMessage = "Правильно заполните все поля"
                } else {
                    this.loading = true;
                    this.temp.phones = [];
                    this.values.forEach((value) => {
                        this.temp.phones.push({type: value.values[0], value: value.values[1]})
                    });
                    this.saveProfile(this.temp).then(() => {
                        this.loading = false;
                        this.switchPopup(false);
                    })
                }
            },
            handleImageClick() {
                this.$refs.file.click()
            }
        },
        created() {
            this.temp = Object.assign({}, this.employee);
            this.temp.phones.forEach((phone) => {
                this.values.push({values: [phone.type, phone.value]})
            });
        }
    }
</script>

<style scoped>
    .profile-photo {
        cursor: pointer;
        margin: auto;
    }

</style>
